import type { StorageZap } from "./useQueryStorageZaps";

// Search-only rows have no enabled state. Owner/folder hydration may still be pending.
export function hasZapStorageMetadata(
  zap: Pick<Partial<StorageZap>, "isEnabled">,
): boolean {
  return zap.isEnabled !== undefined;
}
